import { render, staticRenderFns } from "./ChangeLanguage.vue?vue&type=template&id=520457e2"
import script from "./ChangeLanguage.vue?vue&type=script&lang=js"
export * from "./ChangeLanguage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('520457e2')) {
      api.createRecord('520457e2', component.options)
    } else {
      api.reload('520457e2', component.options)
    }
    module.hot.accept("./ChangeLanguage.vue?vue&type=template&id=520457e2", function () {
      api.rerender('520457e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ChangeLanguage.vue"
export default component.exports